export const formatMoney = (value?: number): string =>
  `$${value ? value.toFixed(2) : 0}`;

export const formatRating = (value?: number): string =>
  value ? value.toFixed(1) : '0';
